<template>
    <div class="wrapper">
        <div class="follow">
            <input class="btn__checkbox" type="checkbox" :disabled="user.id == null" :id="array.id" :checked="array.in_wishlist === 1" @change="updateWish($event,array.id)"/>
            <label class="btn-love" :for="array.id">
                <svg width="17.916626" height="15.586182" viewBox="0 0 17.9166 15.5862" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs/>
                    <path id="Vector" d="M0.62 5.2C0.62 9.79 6.04 13.95 8.95 14.92C11.87 13.95 17.29 9.79 17.29 5.2C17.29 2.67 15.23 0.62 12.7 0.62C11.15 0.62 9.78 1.39 8.95 2.57C8.12 1.39 6.75 0.62 5.2 0.62C2.67 0.62 0.62 2.67 0.62 5.2Z" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.250000"/>
                </svg>

            </label>
        </div>
        <div class="flex">
            <div class="category">{{ array.category_name }}</div>
            <div class="year">{{ array.year }}</div>
        </div>
        <div class="name">{{ array.name }}</div>
        <div class="desc" v-html="array.description">
        </div>
        <div class="characteristics">
            <div class="item">SKU: {{ array.weight }}</div>
            <div class="item">Production Capacity: {{ array.unit_of_measure }}</div>
            <div class="item">Condition & Availability: {{ array.type_of_material }}</div>
        </div>
        <ButtonOrange style="width: 100%;" @click="this.$scrollTo('footer');">Get in Touch!</ButtonOrange>
    </div>
</template>

<script>
import ButtonOrange from '../UI/ButtonOrange.vue';
import axios from "axios";
    export default {
        components: {
            ButtonOrange,
        },
        props: {
            array: [Array, Object],
        },
        methods: {
            async updateWish(event, id) {
                const data = { event, id };
                this.updateWishlist(data);
            },
            async updateWishlist(event) {
                try {
                    let fData = new FormData();
                    fData.append("isChecked", event.event.target.checked);
                    fData.append("event_id", event.id);
                    const response = await axios.post('/post/checked-wishlist', fData);
                } catch (error) {
                    console.error('Error updating wishlist:', error);
                }
            },
            
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        }
    }
</script>

<style scoped>
.btn__checkbox {
  display: none;
}
.btn-love svg path {
  transition: fill 0.5s ease;
}
.btn__checkbox:checked + .btn-love svg path {
  fill: black;
}
.follow {
    position: absolute;
    top: 0px;
    right: 0px;
    border-radius: 100px;
    background: rgb(222, 230, 234);
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 3;
}
.btn-love {
    width: 17.67px;
    height: 18.3px;
}
.wrapper{
    position: relative;
}
.flex{
    display: flex;
    justify-content: space-between;
    color: rgb(5, 5, 5);
    font-family: Satoshi;
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    margin-bottom: 16px;
    margin-right: 60px;
}
.wrapper .name{
    /* Header/H2: 32px Medium */
color: rgb(5, 5, 5);
font-family: Satoshi;
font-size: 32px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 15px;
}
.wrapper .desc{
/* Paragraph/P3: 16px Regular */
color: rgb(85, 98, 114);
font-family: Satoshi;
font-size: 16px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 24px;
}
.wrapper .characteristics{
display: flex;
flex-direction: column;
gap: 24px;
padding: 24px 0;
border-top: 1px solid rgb(222, 230, 234);
border-bottom: 1px solid rgb(222, 230, 234);
margin-bottom: 24px;
}
@media (max-width: 768px) {
    .wrapper .name{
        font-size: 24px;
    }
}

</style>